import React from "react";
import { BokehParticles } from "@/components/effects/BokehParticles";
import { LightStreaks } from "@/components/effects/LightStreaks";
import { Reveal } from "@/components/effects/Reveal";

export const PageHero = ({ eyebrow, title, accent, suffix, subtitle, children }) => {
  return (
    <section data-testid="page-hero" className="relative pt-44 pb-24 sm:pt-52 sm:pb-32 overflow-hidden">
      <div
        className="absolute inset-0 -z-10"
        style={{
          background:
            "radial-gradient(60% 60% at 50% 0%, rgba(255,46,147,0.10) 0%, transparent 65%)," +
            "radial-gradient(60% 60% at 80% 100%, rgba(24,211,255,0.10) 0%, transparent 65%)," +
            "linear-gradient(180deg, #000, #050507, #000)",
        }}
      />
      <div className="aperture-ring absolute -top-32 -right-32 w-[60vmin] h-[60vmin] opacity-20" />
      <LightStreaks count={3} />
      <BokehParticles count={10} />

      <div className="relative max-w-[1280px] mx-auto px-6 sm:px-10 text-center">
        {eyebrow && (
          <Reveal>
            <p className="text-[11px] tracking-luxe uppercase text-white/45 mb-5 inline-flex items-center gap-3">
              <span className="w-7 h-px bg-gradient-to-r from-[#ff2e93] to-transparent" />
              {eyebrow}
              <span className="w-7 h-px bg-gradient-to-l from-[#18d3ff] to-transparent" />
            </p>
          </Reveal>
        )}
        <Reveal delay={120}>
          <h1 className="font-display text-5xl sm:text-6xl md:text-7xl leading-[1.02] max-w-5xl mx-auto">
            <span className="text-chrome">{title}</span>{" "}
            {accent && <span className="italic text-magcyan">{accent}</span>}
            {suffix && <span className="text-chrome">{suffix}</span>}
          </h1>
        </Reveal>
        {subtitle && (
          <Reveal delay={260}>
            <p className="mt-8 text-white/65 font-body max-w-2xl mx-auto leading-relaxed">{subtitle}</p>
          </Reveal>
        )}
        {children && (
          <Reveal delay={400}>
            <div className="mt-10">{children}</div>
          </Reveal>
        )}
      </div>
    </section>
  );
};

export default PageHero;
